import { combineReducers } from 'redux';
import ObjectUtil from '@leverege/object-util'
import ArrayUtil from '@leverege/array-util'

import ScenarioActions from '~/actions/ScenarioActions.js'

const initialState = {
  status : 'none',
  projectId : null,
  items : []
};

function scenarios( state = initialState, action ) {

  switch ( action.type ) {

    case ScenarioActions.GET_SCENARIOS:
      // TODO : MERGE IF STARTINDEX > 0
      return {
        projectId : action.projectId,
        items : action.scenarios,
        hasMore : false
      }

    // case ScenarioActions.UPDATE_SCENARIO: {
    //   let copy = JSON.parse( JSON.stringify( state ) );
    //   let index = ArrayUtil.replace( copy.items, 'id', action.scenario.id, action.scenario )
    //   return copy;
    // }
    case ScenarioActions.CREATE_SCENARIO: {
      const copy = JSON.parse( JSON.stringify( state ) );
      const sCopy = ObjectUtil.copy( action.scenario )
      delete sCopy.scenarioData
      copy.items.push( sCopy )
      return copy
    }

    case ScenarioActions.REMOVE_SCENARIO: {
      const copy = JSON.parse( JSON.stringify( state ) );
      const index = ArrayUtil.remove( copy.items, 'id', action.id )
      return copy;
    }

    default:
      return state
  }
}

module.exports = scenarios;
